import { Box, Container, Link, List, Stack, useTheme } from '@mui/material';
import { ArrowDown2, ArrowLeft2 } from 'iconsax-react';
import Image from 'next/image';
import { FC } from 'react';
import { Items } from './Data';
import { QrHeader } from './Styles';
import { CoinT } from './types/types';
import dynamic from 'next/dynamic';
import useResponsive from '@/hooks/useResponsive';

const CustomPopover = dynamic(() => import('../Popover'));
const Button = dynamic(() => import('@/components/Button'));
const Paper = dynamic(() => import('@/components/Paper'));
const Typography = dynamic(() => import('@/components/Typography'));

const Header: FC = () => {
  const theme = useTheme();
  const { matches } = useResponsive();

  const submenuColumnCount = (num: any) => {
    if (!num) {
      return 12;
    } else {
      return Math.floor(12 / num);
    }
  };

  return (
    <>
      <Stack
        direction="row"
        sx={{
          py: 2.5,
          px: 5,
          top: 0,
          backgroundColor: 'white',
          display: 'flex',
          position: 'sticky',
          borderBottom: '1px solid',
          borderColor: theme.palette.textColor.A20,
          zIndex: 1999,
          [theme.breakpoints.down('lg')]: {
            display: 'none'
          }
        }}
      >
        <Stack
          direction="row"
          spacing={0}
          sx={{ alignItems: 'center', flex: 1 }}
        >
          <a href="/" style={{ height: 42 }}>
            <Image
              priority
              src="/assets/NewLogo.svg"
              alt="logo"
              width={120}
              height={42}
              style={{ marginLeft: 20 }}
            />
          </a>
          {Items.map((item, index) => {
            if (item?.submenu) {
              return (
                <CustomPopover
                  key={index}
                  button={
                    <Stack
                      key={index}
                      direction="row"
                      sx={{
                        py: 1.5,
                        px: 3,
                        cursor: 'pointer',
                        alignItems: 'center',
                        backgroundColor: 'transparent',
                        borderRadius: '0',
                        '&:hover': {
                          backgroundColor: theme.palette.secondary.A80,
                          borderRadius: '8px'
                        }
                      }}
                    >
                      <Box sx={{ cursor: 'pointer' }}>
                        <Typography
                          color={theme.palette.textColor.A80}
                          variant="body2"
                          sx={{ cursor: 'pointer', textDecoration: 'none' }}
                        >
                          {item.title}
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          marginLeft: 1,
                          display: 'flex',
                          cursor: 'pointer'
                        }}
                      >
                        <ArrowDown2
                          size="16"
                          color={theme.palette.grayBackground.A100}
                        />
                      </Box>
                    </Stack>
                  }
                >
                  <Paper elevation={14} sx={{ borderRadius: 3 }}>
                    <Container maxWidth="lg">
                      <Box
                        dir="rtl"
                        p={6}
                        margin={{
                          xs: 'auto 2rem',
                          sm: '0',
                          lg: '0',
                          xl: '0'
                        }}
                        sx={{
                          direction: 'rtl',
                          display: 'grid',
                          gridTemplateColumns: `repeat(${item.submenu.length}, 1fr)`
                        }}
                        maxHeight="100%"
                      >
                        {item.submenu.map(
                          (coinColumn: CoinT[], columnIndex: number) => (
                            <Box
                              key={columnIndex}
                              dir="rtl"
                              sx={{
                                height: '100%'
                              }}
                              maxHeight="100%"
                            >
                              {coinColumn.map(
                                (coin: CoinT, coinIndex: number) => (
                                  <Box key={coinIndex}>
                                    <List
                                      sx={{
                                        py:
                                          item.title === 'خرید ارز دیجیتال'
                                            ? 0
                                            : 1
                                      }}
                                    >
                                      <a
                                        href={coin.link}
                                        style={{ textDecoration: 'none' }}
                                      >
                                        <Stack
                                          direction="row"
                                          spacing={12}
                                          sx={{
                                            alignItems: 'center',
                                            cursor: 'pointer',
                                            py:
                                              item.title === 'خرید ارز دیجیتال'
                                                ? 1
                                                : 3,
                                            px: 4,
                                            '&:hover': {
                                              backgroundColor:
                                                theme.palette.secondary.A80,
                                              borderRadius: '8px'
                                            },
                                            '&:hover .arrow': {
                                              opacity: '100%',
                                              display: 'flex'
                                            }
                                          }}
                                        >
                                          <Box
                                            sx={{
                                              display: 'flex',
                                              gap: '0.5rem',
                                              alignItems: 'center',
                                              minWidth: '160px',
                                              flex: '50%'
                                            }}
                                          >
                                            {coin.path ? (
                                              <Image
                                                src={coin.icon}
                                                alt={coin.subtitle}
                                                width={32}
                                                height={32}
                                              />
                                            ) : (
                                              coin.icon
                                            )}
                                            <Box
                                              sx={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                flex: '50%'
                                              }}
                                            >
                                              <Typography
                                                color={
                                                  theme.palette.textColor.A60
                                                }
                                                variant="body2"
                                                weight="bold"
                                              >
                                                {coin.title}
                                              </Typography>
                                              <Typography
                                                color={
                                                  theme.palette.textColor.A50
                                                }
                                                fontSize={12}
                                              >
                                                {coin.subtitle}
                                              </Typography>
                                            </Box>
                                          </Box>
                                          <Box
                                            className="arrow"
                                            sx={{
                                              opacity: '0',
                                              marginLeft: 'auto',
                                              '&:hover': {
                                                backgroundColor:
                                                  theme.palette.secondary.A80,
                                                borderRadius: '8px',
                                                display: 'flex'
                                              }
                                            }}
                                          >
                                            <ArrowLeft2
                                              size="18"
                                              color="#292D32"
                                            />
                                          </Box>
                                        </Stack>
                                      </a>

                                      <Box>{coin.button}</Box>
                                    </List>
                                  </Box>
                                )
                              )}
                            </Box>
                          )
                        )}
                        {submenuColumnCount(item.submenu.length) === 4 ? (
                          <Box
                            sx={{
                              position: 'absolute',
                              right: 24,
                              bottom: 24,
                              display: 'flex',
                              gridTemplateColumns: '1fr 1fr 1fr', // Set 2 columns for this scenario
                              gap: '10px'
                              // width: '100%'
                            }}
                          >
                            <a
                              href="/price"
                              style={{
                                textDecoration: 'none',
                                color: theme.palette.textColor.A80
                              }}
                            >
                              <Button
                                fullWidth
                                sx={{ direction: 'rtl', padding: '10px 45px' }}
                                color="secondary"
                              >
                                <Stack
                                  justifyContent="center"
                                  alignItems="center"
                                  sx={{ marginLeft: '10px' }}
                                >
                                  <ArrowLeft2 size="24" color="#222531" />
                                </Stack>
                                مشاهده همه رمزارزها
                              </Button>
                            </a>
                          </Box>
                        ) : submenuColumnCount(item.submenu.length) === 6 ? (
                          <Box
                            sx={{
                              position: 'absolute',
                              right: 24,
                              bottom: 24,
                              display: 'flex',
                              width: '46%',
                              gridTemplateColumns: '1fr 1fr', // Set 2 columns for this scenario
                              gap: '10px'
                            }}
                          >
                            <Button
                              href="https://rabex.ir/help"
                              fullWidth
                              color="secondary"
                            >
                              <Image
                                src="/assets/arrow.svg"
                                alt=""
                                width={24}
                                height={24}
                                style={{ marginRight: '10px' }}
                              />
                              راهنمای کامل
                            </Button>
                          </Box>
                        ) : (
                          ''
                        )}
                      </Box>
                    </Container>
                  </Paper>
                </CustomPopover>
              );
            } else {
              return (
                <Stack
                  key={index}
                  direction="row"
                  sx={{
                    py: 1.5,
                    px: 3,
                    '&:hover': {
                      alignItems: 'center',
                      backgroundColor: theme.palette.secondary.A80,
                      borderRadius: '8px'
                    }
                  }}
                >
                  <a
                    key={index}
                    {...(item.blank && { target: '_blank' })}
                    href={item.link}
                    style={{
                      cursor: 'pointer',
                      textDecoration: 'none'
                    }}
                  >
                    <Typography
                      color={theme.palette.textColor.A80}
                      variant="body2"
                    >
                      {item.title}
                    </Typography>
                  </a>
                </Stack>
              );
            }
          })}
        </Stack>
        <Stack
          gap={2}
          direction="row"
          sx={{
            justifyContent: 'end',
            alignItems: 'center'
          }}
        >
          <a
            href="https://p.rabex.ir/auth/login"
            style={{
              textDecoration: 'none',
              cursor: 'pointer'
            }}
          >
            <Button
              color="secondary"
              size="small"
              className="button_1"
              sx={{
                '&:after': {
                  animationDelay: '1.5s !important'
                },
                position: 'relative',
                overflow: 'hidden'
              }}
            >
              ورود
            </Button>
          </a>
          <a
            href="https://p.rabex.ir/auth/register"
            style={{
              textDecoration: 'none',
              cursor: 'pointer'
            }}
          >
            <Button sx={{ width: matches({ xs: 70, lg: 135 }) }} size="small">
              ثبت نام
            </Button>
          </a>
          <CustomPopover
            placement="bottom-end"
            button={
              <QrHeader id="qr">
                <Image
                  priority
                  src="/assets/Mobile.svg"
                  width={38}
                  height={38}
                  alt="mobile"
                />
              </QrHeader>
            }
          >
            <Paper elevation={14} sx={{ borderRadius: 3 }}>
              <Stack
                gap={3}
                sx={{ p: 4, alignItems: 'center', justifyContent: 'center' }}
              >
                <Image
                  src="/assets/qrCode.svg"
                  width={150}
                  height={145}
                  alt="qrcode"
                />
                <a href="https://rabex.ir/download/" title="نسخه اندروید">
                  <Stack
                    direction="row"
                    gap={1}
                    px={4}
                    py={2}
                    bgcolor="#EFF2F5"
                    borderRadius={2}
                    alignItems="center"
                    justifyContent="center"
                    sx={{ cursor: 'pointer' }}
                  >
                    <Image
                      src="/assets/Android.svg"
                      width={25}
                      height={24}
                      alt="android"
                    />
                    <Typography variant="body1" weight="bold">
                      نسخه اندروید
                    </Typography>
                  </Stack>
                </a>
              </Stack>
            </Paper>
          </CustomPopover>
        </Stack>
      </Stack>
    </>
  );
};

export default Header;
